import { isEmpty, compact } from 'lodash';

const API_ENDPOINT = 'https://process.filestackapi.com';

/*::
type FileStackImageConfig = {
  policy: string,
  signature: string,
  handle: string,
  transform?: {
    resize?: {
      width?: number,
      height?: number,
      fit?: 'clip' | 'crop' | 'scale' | 'max',
      align?: 'center' | 'top' | 'bottom' | 'left' | 'right' | 'faces'
    }
  }
}
*/

/**
 * A class to build urls for images hosted on Filestack.
 *
 * For image transformation options refer to:
 * https://www.filestack.com/docs/image-transformations/
 *
 * Currently, this class doesn't support the option 'compress' if you were to
 * pass it under config.transform.
 */
class FileStackImage {
  constructor(config /*: FileStackImageConfig */) {
    this.updateParams(config);
    this.transformations = config.transform || {};
  }

  static url(image) {
    return new FileStackImage(image).url;
  }

  get url() {
    const hasTransform = !isEmpty(this.transformations);
    return compact([
      API_ENDPOINT,
      `security=${this.stringifyParams(this.security)}`,
      hasTransform && this.stringifyTransformations(this.transformations),
      this.handle,
    ]).join('/');
  }

  updateParams(config) {
    this.security = {
      policy: config.policy,
      signature: config.signature,
    };
    this.handle = config.handle;
    return this;
  }

  stringifyParams(params) {
    const pairs = Object.keys(params).map(key => `${key}:${params[key]}`);
    return pairs.join(',');
  }

  stringifyTransformations(transformations) {
    const pairs = Object.keys(transformations).map(
      transform =>
        `${transform}=${this.stringifyParams(transformations[transform])}`,
    );
    return pairs.join('/');
  }
}

export default FileStackImage;
